"use client"

import type { ReactNode } from "react"

const RootPage = ({ children }: { children: ReactNode }) => {
  return (
    <div
      id="app-root"
      className="mx-auto flex min-h-vh max-w-full flex-col bg-white text-gray-900 md:max-w-[768px]"
    >
      {/* 메인 */}
      {children}
    </div>
  )
}

export default RootPage
